import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  "Content-Type": "application/json",
});

const parseError = async (response, fallback) => {
  const text = await response.text();
  try {
    const parsed = JSON.parse(text);
    return parsed?.message || parsed?.Message || parsed?.error || fallback;
  } catch {
    return text?.trim() || fallback;
  }
};

const queryString = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") search.set(key, value);
  });
  const text = search.toString();
  return text ? `?${text}` : "";
};

export const fetchPaymentOverview = async (params) => {
  const response = await fetch(`${API_BASE_URL}/Payments/admin/overview${queryString(params)}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) throw new Error(await parseError(response, "فشل تحميل الملخص"));
  return response.json();
};

export const fetchPaymentTransactions = async (params) => {
  const response = await fetch(`${API_BASE_URL}/Payments/admin/transactions${queryString(params)}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) throw new Error(await parseError(response, "فشل تحميل المعاملات"));
  return response.json();
};

export const fetchPaymentDetail = async (id) => {
  const response = await fetch(`${API_BASE_URL}/Payments/admin/${id}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) throw new Error(await parseError(response, "فشل تحميل الدفع"));
  return response.json();
};

export const refreshPayment = async (id) => {
  const response = await fetch(`${API_BASE_URL}/Payments/admin/${id}/refresh`, {
    method: "POST",
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error(await parseError(response, "فشل التحديث من Kashier"));
  return response.json();
};

export const refundPayment = async (id, body) => {
  const response = await fetch(`${API_BASE_URL}/Payments/admin/${id}/refund`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error(await parseError(response, "فشل الاسترداد"));
  return response.json();
};

export const fetchKashierSettings = async () => {
  const response = await fetch(`${API_BASE_URL}/Payments/admin/settings`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) throw new Error(await parseError(response, "فشل تحميل الإعدادات"));
  return response.json();
};

export const exportPayments = async (params) => {
  const response = await fetch(`${API_BASE_URL}/Payments/admin/export${queryString(params)}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) throw new Error(await parseError(response, "فشل التصدير"));
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "girabat-payments.csv";
  link.click();
  URL.revokeObjectURL(url);
};
